<div class="dynamic-field" [formGroup]="group">
  <label for="coordinateSystemSelect">{{ config.label | translate }}</label>
  <select
    id="coordinateSystemSelect"
    class="form-select"
    [formControlName]="config.name"
    [ngClass]="{ error: isErrorDetected() }"
    >
    @if (config.allValuesEnabled) {
      <option value="">
        {{ 'GK.DYNAMIC_FORM.ALL' | translate }}
      </option>
    }
    @for (coordinateSystem of coordinateSystems; track coordinateSystem) {
      <option
        [value]="coordinateSystem.id"
        >
        {{ coordinateSystem.name }}
      </option>
    }
  </select>
</div>
